define('app/sf/ids/sf-ids-filter',[],function () {
	"use strict";
	return sfIdsFilter;
	function sfIdsFilter(route) {
		return angular.mapMany(route, extractId);
		function extractId(idAndValue, key) {
			var obj = {};
			var id = null;
			if (idAndValue) {
				var results = /^(?:[1-9]\d+|\d(?=-|$)|$)/.exec(idAndValue);
				if (results && results[0]) {
					id = results[0];
				}
			}
			obj[key + "Id"] = id ? Number(id) : null;
			return obj;
		}
	}
});
